import * as Modules from './module-registry';
import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

function setupModules(): void {

  const appModules = applicationModuleRegistry.getAll();

  if ( appModules.length > 0 ) {
    return;
  }

  Modules.setupAllModules();

}

export {
  setupModules
}
